import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import _ from 'lodash';
export default /*#__PURE__*/_defineComponent({
  __name: 'DataTable',
  props: {
    selectedObject: null,
    allSelectableIds: null
  },
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;

    // this component fixed some very weird issues & bugs that v-data-table has thus should be the default / first choice over v-data-table
    // TODO: we should think if we support passing non array value when `single-select` is true, see the use cause of table-funds in ix-dialog-metric-aggregation

    var attrs = useAttrs();
    var normalizeIds = function normalizeIds(value) {
      if (Array.isArray(value)) return _toConsumableArray(value);
      if (value == null || value === '') return [];
      return [value];
    };
    var idsEqual = function idsEqual(a, b) {
      return _.isEqual(_.sortBy(a), _.sortBy(b));
    };
    var selected = ref(normalizeIds(attrs === null || attrs === void 0 ? void 0 : attrs.value));
    /** Skip the page-scoped @input that Vuetify emits right after @toggle-select-all. */
    var ignoreNextInput = ref(false);
    watch(function () {
      return attrs.value;
    }, function (value) {
      var next = normalizeIds(value);
      // Don't clobber in-progress local selection with a stale parent value.
      if (idsEqual(next, selected.value)) return;
      selected.value = next;
    });
    var emitSelection = function emitSelection(ids) {
      var next = _toConsumableArray(new Set(ids));
      if (idsEqual(next, normalizeIds(attrs.value))) {
        selected.value = next;
        return;
      }
      selected.value = next;
      emit('input', next);
    };
    var hasCrossPageSelectAll = computed(function () {
      return Array.isArray(props.allSelectableIds);
    });
    var onToggleSelectAll = function onToggleSelectAll(_ref2) {
      var value = _ref2.value;
      if (!hasCrossPageSelectAll.value) return;
      if (attrs['single-select'] || attrs.singleSelect) return;
      ignoreNextInput.value = true;
      emitSelection(value ? _toConsumableArray(props.allSelectableIds || []) : []);
    };
    var onItemSelected = function onItemSelected(_ref3) {
      var item = _ref3.item,
        value = _ref3.value;
      if (!selected.value) {
        selected.value = [];
      }
      var next = _toConsumableArray(selected.value);

      // Simple single-select workaround: clear previous selection when selecting new item
      if (value && (attrs['single-select'] || attrs.singleSelect)) {
        next = [item.id];
      } else if (value) {
        if (!next.includes(item.id)) {
          next = [].concat(_toConsumableArray(next), [item.id]);
        }
      } else {
        next = next.filter(function (id) {
          return id !== item.id;
        });
      }
      emitSelection(next);
    };
    var onInput = function onInput(selectedItems) {
      if (ignoreNextInput.value) {
        ignoreNextInput.value = false;
        return;
      }

      // v-data-table sends CURRENT page's SELECTED item objects
      var items = attrs.items || [];
      var pageSelectedIds = (selectedItems || []).map(function (item) {
        return item.id;
      });
      var pageSelectedIdSet = new Set(pageSelectedIds);
      var newSelected = _toConsumableArray(selected.value);
      var _iterator = _createForOfIteratorHelper(items),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (!pageSelectedIdSet.has(item.id)) {
            var index = newSelected.indexOf(item.id);
            if (index !== -1) {
              newSelected.splice(index, 1);
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(pageSelectedIds),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var id = _step2.value;
          newSelected.push(id);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var selectedSet = _toConsumableArray(new Set(newSelected));
      if (idsEqual(selectedSet, selected.value)) {
        return;
      }
      emitSelection(selectedSet);
    };
    var selectedObject = computed(function () {
      var _attrs$items;
      return attrs === null || attrs === void 0 ? void 0 : (_attrs$items = attrs.items) === null || _attrs$items === void 0 ? void 0 : _attrs$items.filter(function (_ref4) {
        var id = _ref4.id;
        return selected.value.includes(id);
      });
    });
    return {
      __sfc: true,
      props: props,
      attrs: attrs,
      emit: emit,
      normalizeIds: normalizeIds,
      idsEqual: idsEqual,
      selected: selected,
      ignoreNextInput: ignoreNextInput,
      emitSelection: emitSelection,
      hasCrossPageSelectAll: hasCrossPageSelectAll,
      onToggleSelectAll: onToggleSelectAll,
      onItemSelected: onItemSelected,
      onInput: onInput,
      selectedObject: selectedObject,
      _: _
    };
  }
});